<template>
<h1 class="memberName">
    {{before_text}}{{memberName}}{{after_text}}
</h1>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "WYSIWYG",
  props: ["before_text", "after_text", "acf_fc_layout"],
  created(){
      this.$store.dispatch("member/getMemberDetails")
  },
  computed:{
      ...mapGetters({
          memberName: "member/firstName"
    })
  }
};
</script>

<style lang="scss" scoped>
	.memberName {
		color: $CTred;
		font-size: 3em;
	}
</style>
